import React from "react";
import { Link } from "react-router-dom";
// import logo from "../assets/logo.png"; // apna logo path daalo
// import astroImg from "../assets/astro.png"; // astro person image path daalo
import name from '../../assets/Home/name.png';
import profilephoto2 from "../../assets/Home/profilephoto2.jpg"

function Navbar() {
  return (
    <nav className="navbar bg-dark shadow-sm fixed-top">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        
        {/* Left: Logo */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img
            src={name}
            alt="Logo"
            style={{width:"250px", marginRight: "8px" }}
          />
        </Link>

        {/* Right: Home + Astro Image */}
        <div className="d-flex align-items-center">
          <Link className="nav-link fw-semibold me-3" style={{color: "#fff"}} to="/">
            Home
          </Link>
          <img
            src={profilephoto2}
            alt="Astro"
            className="rounded-circle border"
            style={{ height: "65px", width: "65px", objectFit: "cover" }}
          />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
